import { IMG, SCHEDULE, AUDIENCE } from "./data";

const PILLARS = [
  ["Curated, not crowded", "A maximum of 20 hand-selected guests per session, chosen for a productive mix of expertise and commercial perspective."],
  ["Origin-led", "Each month features one African coffee nation: its terroir, its farmers, its trade data and its cup."],
  ["Commercially purposeful", "Roasters, buyers, importers, investors and diplomats in one room, with real conversations about supply and opportunity."],
  ["Every last Friday", "A three-hour daytime experience in central London, 11:00 to 14:00, from June 2026 to July 2027."],
];

export const HowWeHost = () => (
  <section className="max-w-7xl mx-auto px-5 py-20" data-testid="events-how-we-host">
    <div className="grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-4">
        <p className="overline text-[#E5332A]">How we host</p>
        <h2 className="font-display text-3xl sm:text-4xl font-bold mt-3 leading-tight">Intimate. Exclusive. Purposeful.</h2>
        <blockquote className="mt-8 border-l-4 border-[#E5332A] pl-5 text-[#3A3A3A] italic leading-relaxed">
          "Africa produces 12% of the world's coffee. It receives a fraction of the margin, the story, and the credit. The Origin Cup exists to change that narrative, one cup at a time."
          <span className="block not-italic text-sm mt-3 text-[#575757]">Wilbert Chaniwa, CEO, Africa One Group</span>
        </blockquote>
      </div>
      <div className="lg:col-span-8 grid sm:grid-cols-2 gap-px bg-[#E7E7E7] border border-[#E7E7E7]">
        {PILLARS.map(([t, d], i) => (
          <div key={t} className="bg-white p-7">
            <p className="font-mono-d text-xs text-[#E5332A]">0{i + 1}</p>
            <p className="font-display text-xl font-bold mt-2">{t}</p>
            <p className="text-sm text-[#575757] mt-2 leading-relaxed">{d}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const Experience = () => (
  <section className="bg-[#F4F4F4]" data-testid="events-experience">
    <div className="max-w-7xl mx-auto px-5 py-20 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-5 space-y-4">
        <p className="overline text-[#E5332A]">The experience</p>
        <h2 className="font-display text-3xl sm:text-4xl font-bold leading-tight">A structured, multi-sensory journey</h2>
        <img src={IMG.cupping} alt="Coffee cup resting on roasted beans" className="w-full h-64 object-cover" />
        <img src={IMG.lunch} alt="Guests sharing coffee over lunch" className="w-full h-48 object-cover hidden lg:block" />
      </div>
      <ol className="lg:col-span-7">
        {SCHEDULE.map(([t, title, d]) => (
          <li key={t} className="grid grid-cols-[4.5rem_1fr] gap-4 py-5 border-b border-[#DADADA] last:border-b-0">
            <span className="font-mono-d text-sm text-[#E5332A] pt-1">{t}</span>
            <div><p className="font-display text-lg font-bold">{title}</p><p className="text-sm text-[#575757] mt-1 leading-relaxed">{d}</p></div>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export const Audience = () => (
  <section className="max-w-7xl mx-auto px-5 py-20" data-testid="events-audience">
    <p className="overline text-[#E5332A]">Who should attend</p>
    <h2 className="font-display text-3xl sm:text-4xl font-bold mt-3 max-w-2xl leading-tight">Convened for people who move coffee, capital and culture</h2>
    <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[#E7E7E7] border border-[#E7E7E7] mt-10">
      {Object.entries(AUDIENCE).map(([c, d]) => (
        <div key={c} className="bg-white p-5 hover:bg-[#FFF5F4] transition-colors">
          <p className="font-bold text-sm">{c}</p>
          <p className="text-xs text-[#575757] mt-2 leading-relaxed">{d}</p>
        </div>
      ))}
    </div>
  </section>
);
